module.exports = __webpack_public_path__ + "img/dummy-avatar.7ea3c4ed.jpg";